var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssociateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.584,
    viewBox: "0 0 18 14.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-check-solid",
    d: "M2.735,3.646A3.646,3.646,0,1,1,6.381,7.292,3.646,3.646,0,0,1,2.735,3.646ZM0,13.738A5.078,5.078,0,0,1,5.079,8.659h2.6a5.078,5.078,0,0,1,5.079,5.079.846.846,0,0,1-.846.846H.846A.846.846,0,0,1,0,13.738Zm17.8-8.7L14.157,8.688a.681.681,0,0,1-.966,0L11.368,6.865a.683.683,0,0,1,.966-.966l1.339,1.339,3.162-3.165a.683.683,0,0,1,.966.966Z",
    fill: "#686868"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssociateIcon);
export default __webpack_public_path__ + "static/media/associate-icon.f26b80a2a447933d810b777aef01da8c.svg";
export { ForwardRef as ReactComponent };